import React from 'react'
import { Link, graphql } from 'gatsby'

import routes from '../../config/routes'
import Box from '../../styled/Box'
import Button from '../../styled/Button'
import Layout from '../../components/Layout'
import PageHeader from '../../components/PageHeader'
import Posts from '../../components/Posts'
import SEO from '../../components/SEO'

export const MAX_POSTS_TO_SHOW = 100

function BlogPage(props = {}) {
  const posts = props.data.allMdx.edges
  return (
    <Layout>
      <SEO title="Blog" />
      <PageHeader
        title="Blog"
        description="On design, development, productivity, leadership, and more."
      />
      <Box mb="l">
        <Posts posts={posts} />
        {posts.length === MAX_POSTS_TO_SHOW && (
          <Box textAlign="center">
            <Button as={Link} to={routes.blog.archive}>
              View older posts
            </Button>
          </Box>
        )}
      </Box>
    </Layout>
  )
}

export const pageQuery = graphql`
  query {
    allMdx(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { draft: { ne: true } } }
      # TODO: Ideally this is tied to MAX_POSTS_TO_SHOW.
      limit: 100
    ) {
      edges {
        node {
          excerpt
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            tags
          }
          fields {
            slug
          }
        }
      }
    }
  }
`

export default BlogPage
